<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <h4><i class="fas fa-clipboard-check"></i> ใบรับสินค้า</h4>

          <b-card
            no-body
            class="mt-3"
          >
            <b-tabs
              card
              v-model="tabIndex"
              @input="onTabChange"
            >
              <!-- WAITING_BM: รอผู้จัดการคลังอนุมัติ -->
              <b-tab>
                <template #title>
                  รอผู้จัดการคลังอนุมัติ ({{ waitingBmList.length }})
                  <span
                    v-if="showWaitingBmRedDot"
                    class="tab-red-dot"
                  ></span>
                </template>
                <GrListTab
                  table-id="grWaitingBmTable"
                  :items="waitingBmList"
                  :filter="filter"
                  :show-edit="true"
                  :show-delete="true"
                  :show-add-button="true"
                  @update:filter="filter = $event"
                  @add-gr="openCreateModal"
                  @edit="openEditModal"
                  @info="goToDetail"
                  @delete="deleteGoodsReceive"
                />
              </b-tab>

              <!-- WAITING_HQ: รอสำนักงานใหญ่อนุมัติ -->
              <b-tab>
                <template #title>
                  รอสำนักงานใหญ่อนุมัติ ({{ waitingHqList.length }})
                </template>
                <GrListTab
                  table-id="grWaitingHqTable"
                  :items="waitingHqList"
                  :filter="filter"
                  :show-edit="false"
                  :show-delete="false"
                  :show-add-button="true"
                  @update:filter="filter = $event"
                  @add-gr="openCreateModal"
                  @edit="openEditModal"
                  @info="goToDetail"
                  @delete="deleteGoodsReceive"
                />
              </b-tab>

              <!-- REJECTED: ถูกปฏิเสธ -->
              <b-tab>
                <template #title>
                  ถูกปฏิเสธ ({{ rejectedList.length }})
                  <span
                    v-if="showRejectedRedDot"
                    class="tab-red-dot"
                  ></span>
                </template>
                <GrListTab
                  table-id="grRejectedTable"
                  :items="rejectedList"
                  :filter="filter"
                  :show-edit="true"
                  :show-delete="true"
                  :show-add-button="true"
                  @update:filter="filter = $event"
                  @add-gr="openCreateModal"
                  @edit="openEditModal"
                  @info="goToDetail"
                  @delete="deleteGoodsReceive"
                />
              </b-tab>

              <!-- COMPLETED: อนุมัติแล้ว -->
              <b-tab title="อนุมัติแล้ว">
                <GrListTab
                  table-id="grConfirmedTable"
                  :items="confirmedList"
                  :filter="filter"
                  :show-edit="false"
                  :show-delete="false"
                  :show-add-button="true"
                  @update:filter="filter = $event"
                  @add-gr="openCreateModal"
                  @info="goToDetail"
                />
              </b-tab>

              <!-- CANCELED: ยกเลิก -->
              <b-tab title="ยกเลิก">
                <GrListTab
                  table-id="grCanceledTable"
                  :items="canceledList"
                  :filter="filter"
                  :show-edit="false"
                  :show-delete="false"
                  :show-add-button="true"
                  @update:filter="filter = $event"
                  @add-gr="openCreateModal"
                  @info="goToDetail"
                />
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
      <GoodsReceiveSelectPOModal
        ref="selectPOModal"
        @created="onGrCreated"
        @updated="onGrUpdated"
        @deleted="onGrDeleted"
        @error="onGrError"
      ></GoodsReceiveSelectPOModal>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import GoodsReceiveSelectPOModal from "../../components/modal/ProductAndStock/GoodsReceiveSelectPOModal.vue";
import Dialog from "../../components/modal/Dialog.vue";
import { mapGetters, mapActions } from "vuex";
import Loading from "@/components/Loading";
import GrListTab from "@/components/ProductAndStock/GrListTab.vue";
import { GR_STATUS } from "@/constants/productStock";
import { ROLES } from "@/constants/user";

export default {
  name: "GoodsReceive",
  components: {
    GoodsReceiveSelectPOModal,
    Dialog,
    Loading,
    GrListTab,
  },
  data() {
    const saved = sessionStorage.getItem("goodsReceiveTab");
    const tabMap = {
      "gr-waiting-bm": 0,
      "gr-waiting-hq": 1,
      "gr-rejected": 2,
      "gr-completed": 3,
      "gr-canceled": 4,
    };
    return {
      isLoading: false,
      deleteTarget: null,
      filter: null,
      tabIndex: tabMap[saved] ?? 0,
      ROLES,
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters({
      getGoodsReceiveList: "moduleGoodsReceive/getGoodsReceiveList",
      isAccessMenu: "moduleUser/getIsAccessMenu",
    }),
    waitingBmList() {
      return (this.getGoodsReceiveList || []).filter(
        gr => gr.status === GR_STATUS.WAITING_BM
      );
    },
    waitingHqList() {
      return (this.getGoodsReceiveList || []).filter(
        gr => gr.status === GR_STATUS.WAITING_HQ
      );
    },
    rejectedList() {
      return (this.getGoodsReceiveList || []).filter(
        gr => gr.status === GR_STATUS.REJECTED
      );
    },
    confirmedList() {
      return (this.getGoodsReceiveList || []).filter(
        gr => gr.status === GR_STATUS.COMPLETED
      );
    },
    canceledList() {
      return (this.getGoodsReceiveList || []).filter(
        gr => gr.status === GR_STATUS.CANCELED
      );
    },
    showWaitingBmRedDot() {
      return (
        this.waitingBmList.length > 0 &&
        this.isAccessMenu([ROLES.ROLE_BRANCH_STOCK_MANAGER])
      );
    },
    showRejectedRedDot() {
      return (
        this.rejectedList.length > 0 &&
        this.isAccessMenu([ROLES.ROLE_STOCK_STAFF]) &&
        !this.isAccessMenu([ROLES.ROLE_BRANCH_STOCK_MANAGER])
      );
    },
  },
  methods: {
    ...mapActions({
      fetchGoodsReceiveList: "moduleGoodsReceive/fetchGoodsReceiveList",
      deleteGoodsReceiveAction: "moduleGoodsReceive/deleteGoodsReceive",
      fetchProductList: "moduleProductInventory/fetchProductList",
    }),
    onTabChange(index) {
      const keys = [
        "gr-waiting-bm",
        "gr-waiting-hq",
        "gr-rejected",
        "gr-confirmed",
        "gr-canceled",
      ];
      sessionStorage.setItem("goodsReceiveTab", keys[index] || "gr-waiting-bm");
      this.filter = "";
    },
    async init() {
      this.isLoading = true;
      try {
        const { clinicUrl, branchUrl } = this.$route.params;
        await Promise.all([
          this.refreshList(),
          this.fetchProductList({ clinicUrl, branchUrl }),
        ]);
      } catch (err) {
        this.showDialogToast("danger", "โหลดรายการใบรับสินค้าไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    refreshList() {
      return this.fetchGoodsReceiveList({
        clinicUrl: this.$route.params.clinicUrl,
        branchUrl: this.$route.params.branchUrl,
      });
    },
    openCreateModal() {
      this.$refs.selectPOModal.show();
    },
    openEditModal(goodsReceive) {
      this.$refs.selectPOModal.show({ goodsReceive });
    },
    goToDetail(goodsReceive) {
      this.$router.push({
        name: "GoodsReceiveDetail",
        params: {
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          grId: goodsReceive.id,
        },
      });
    },
    deleteGoodsReceive(item) {
      this.deleteTarget = item;
      this.$refs.Dialog.showAlertConfirm(
        "ยกเลิกใบรับสินค้านี้ ?",
        "คุณต้องการยกเลิกใบรับสินค้านี้ใช่หรือไม่"
      ).then(result => {
        if (!result.value) return;
        this.isLoading = true;

        this.deleteGoodsReceiveAction({
          clinicUrl: this.$route.params.clinicUrl,
          branchUrl: this.$route.params.branchUrl,
          id: this.deleteTarget.id,
        })
          .then(res => {
            if (res.status === 200) {
              this.deleteTarget = null;
              this.init();
              this.showDialogToast("success", "ยกเลิกรายการใบรับสินค้าสำเร็จ");
            }
          })
          .catch(err => {
            const errorMessage = err.response?.data?.errorMessage;
            const errorMsg =
              typeof errorMessage === "string"
                ? errorMessage
                : "ยกเลิกใบรับสินค้าไม่สำเร็จ กรุณาลองใหม่";
            this.showDialogToast("danger", errorMsg);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    showDialogToast(variant, textDetail) {
      this.$refs.Dialog.showToast(variant, textDetail);
    },
    onGrCreated() {
      this.refreshList();
      this.showDialogToast("success", "เพิ่มรายการใบรับสินค้าสำเร็จ");
    },
    onGrUpdated() {
      this.refreshList();
      this.showDialogToast("success", "แก้ไขรายการใบรับสินค้าสำเร็จ");
    },
    onGrDeleted() {
      this.refreshList();
      this.showDialogToast("success", "ยกเลิกรายการใบรับสินค้าสำเร็จ");
    },
    onGrError(message) {
      this.showDialogToast("danger", message);
    },
  },
};
</script>

<style scoped>
.tab-red-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dd3333;
  border-radius: 50%;
  vertical-align: center;
}

::v-deep #deleteConfirmModal .modal-footer {
  border-top: none;
  padding: 0 1rem 1rem;
}

.delete-modal-footer {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: flex-end;
}

.delete-modal-btn {
  padding: 8px 24px;
}

.btn-back {
  background-color: #fff;
  border-color: #212529;
  color: #212529;
}

.btn-back:hover {
  background-color: #f8f9fa;
  border-color: #212529;
  color: #212529;
}
</style>
